<template>
  <a-row :gutter="16" class="row">
    <a-col :span="14">
      <a-form-item class="codeInput">
        <a-input
          :placeholder="$t('user.login.code.placeholder')"
          v-decorator="[
            'dynamicCode',
            {
              rules: [
                {
                  validator: checkCaptcha,
                },
              ],
              normalize: function(value) {
                if (value) {
                  return Number.isNaN(Number(value)) ? '' : Number(value);
                }
                return value;
              },
            },
          ]"
        />
      </a-form-item>
    </a-col>
    <a-col :span="10">
      <a-button
        class="codeBtn"
        type="primary"
        :disabled="isFetching || timing"
        @click="onGetCaptcha"
      >
        {{
          timing
            ? `${count} ${$t("user.login.code.second")}`
            : buttonText || $t("user.login.code.send")
        }}
      </a-button>
    </a-col>
  </a-row>
</template>

<script>
/** 动态验证码组件 */
import {
  validatePhoneReg,
  validateEmailReg,
  pickPhoneNumberOrEmail,
} from "@/utils/validator";
import { Captcha } from "@/utils/captcha";
import { DynamicCodeType } from "@/models/user";
import UserApi from "@/api/user";

/** 倒计时时间（秒） */
const COUNT_DOWN = 30;

export default {
  name: "CaptchaFormItem",
  props: {
    phoneNumber: {
      type: String,
      default: "",
    },
    dynamicCodeType: {
      type: Number,
      default: DynamicCodeType.LOGIN,
    },
    buttonText: {
      type: String,
      default: "",
    },
    errHandler: {
      type: Function,
      default: undefined,
    },
  },
  data() {
    return {
      /** 当前倒计时 */
      count: 0,
      /** 是否正在计时 */
      timing: false,
      /** 是否正在发送请求 */
      isFetching: false,
    };
  },
  watch: {
    timing: function(val) {
      let interval = 0;
      if (val) {
        this.count = COUNT_DOWN;
        interval = window.setInterval(() => {
          if (this.count <= 1) {
            this.timing = false;
            clearInterval(interval);
            /** 重置秒数 */
            this.count = COUNT_DOWN;
          }
          this.count -= 1;
        }, 1000);
      }
    },
  },
  methods: {
    checkCaptcha(rule, value, callback) {
      const maxValue = 999999;
      const minValue = 100000;
      if (!value) {
        callback(new Error(this.$t("user.login.code.placeholder")));
      }
      if (value > minValue && value <= maxValue) {
        callback();
      }
      callback(new Error(this.$t("user.login.code.placeholder")));
    },

    onGetCaptcha() {
      if (!this.phoneNumber) {
        this.$message.warn(this.$t("user.name.error"));
        return;
      }
      if (
        !validatePhoneReg.test(this.phoneNumber) &&
        !validateEmailReg.test(this.phoneNumber)
      ) {
        this.$message.warn(this.$t("user.name.error"));
        return;
      }
      const captcha = new Captcha();
      captcha.show((token) => {
        const data = {
          phoneNumber: this.phoneNumber,
          token,
          type: this.dynamicCodeType,
        };
        this.isFetching = true;
        /** 判断输入项是手机号还是邮箱 */
        const newData = pickPhoneNumberOrEmail(data);

        UserApi.fetchDynamicCode(newData)
          .then((res) => {
            if (res.data && res.data.code) {
              this.$message.warn(res.data.message);
              if (this.errHandler) {
                this.errHandler(res.data.code);
              }
            } else {
              this.timing = true;
              this.$message.success(this.$t("user.login.code.send.ok"));
            }
          })
          .catch((e) => {
            this.$message.warn(e.message);
          })
          .finally(() => {
            this.isFetching = false;
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../common.less";

.row {
  min-height: 72px;
}
.codeInput {
  margin-bottom: 0;
  .radiusInput;
  & /deep/ .ant-input:focus,
  & /deep/ .ant-input:hover {
    border-color: @mainColor;
    box-shadow: @mainColorBoxShadow !important;
  }
}
.codeBtn {
  width: 100%;
  .radiusBtnGhost;
}
</style>
